import { takeLatest, call, put, all } from 'redux-saga/effects';

import { ApiResponse, getApi } from 'services/_api';
import { CHANNEL, PATH_EDUCACAO } from 'services/_path';
import { Types } from './types';
import { dominiosSuccess, dominiosFailure } from './actions';

function* dominiosRequest() {
	const response: ApiResponse = yield call(
		getApi,
		PATH_EDUCACAO,
		`combo/${CHANNEL}/dominios`,
	);
	if (response.status === 200) {
		yield put(dominiosSuccess(response));
	} else if (response.error) {
		yield put(dominiosFailure(response.message));
	}
}

export default all([takeLatest(Types.DOMINIOS_REQUEST, dominiosRequest)]);
